import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Pagination } from '@cervotech/types/api';
import { merge } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { PageChangedEvent } from './interfaces';

@Component({
  selector: 'cvt-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnInit {
  @Input() pagination!: Pagination;
  @Output() pageChanged = new EventEmitter<PageChangedEvent>();

  pageInputControl = new FormControl();
  itemsPerPageControl = new FormControl();

  @ViewChild('pageInput', { static: false })
  private pageInputElement!: ElementRef;

  constructor() {}

  ngOnInit() {
    merge(
      this.pageInputControl.valueChanges,
      this.itemsPerPageControl.valueChanges
    )
      .pipe(
        filter(() => {
          return (
            this.canEmitWhenInputsChanges() &&
            !this.isValidPage(this.pageInputControl.value)
          );
        }),
        debounceTime(800)
      )
      .subscribe(() => {
        this.pageChanged.emit(
          this.getPageChangedEventValue(this.pageInputControl.value)
        );
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pagination'] && this.pagination) {
      this.itemsPerPageControl.setValue(this.pagination.itemsPerPage, {
        emitEvent: false,
      });
    }
  }

  goNext() {
    const page = this.pagination.currentPage + 1;
    if (this.isValidPage(page)) return;
    this.pageChanged.emit(this.getPageChangedEventValue(page));
  }

  goPrev() {
    const page = this.pagination.currentPage - 1;
    if (this.isValidPage(page)) return;
    this.pageChanged.emit(this.getPageChangedEventValue(page));
  }

  reset() {
    const page = 1;
    this.pageChanged.emit(this.getPageChangedEventValue(page));
    this.pageInputControl.setValue(page, { emitEvent: false });
  }

  onOpeningMenu() {
    setTimeout(() => {
      this.pageInputElement.nativeElement.focus();
    }, 0);
  }

  private getPageChangedEventValue(page: number): PageChangedEvent {
    return {
      page,
      itemsPerPage: this.itemsPerPageControl.value,
    };
  }

  private isValidPage(page: number): boolean {
    // if page === 0 || page === ''
    if (!page) return true;
    if (page > this.pagination.lastPage) {
      return true;
    }
    return false;
  }

  private canEmitWhenInputsChanges(): boolean {
    if (!this.pageInputControl.value && !this.itemsPerPageControl.value) {
      return false;
    }
    return true;
  }
}
